import {
  GET_CARS_START,
  GET_CARS_REQUEST,
  GET_CARS_SUCCESS,
  GET_CARS_FAIL,
  GET_CAR_START,
  GET_CAR_REQUEST,
  GET_CAR_SUCCESS,
  GET_CAR_FAIL,
} from '../constants';

export const getCars = (payload) => ({ payload, type: GET_CARS_REQUEST });
export const getCarsStart = (payload) => ({ type: GET_CARS_START, payload });
export const getCarsSuccess = (payload) => ({
  payload,
  type: GET_CARS_SUCCESS,
});
export const getCarsFail = () => ({ type: GET_CARS_FAIL });

export const getCar = (payload) => ({ payload, type: GET_CAR_REQUEST });
export const getCarStart = () => ({ type: GET_CAR_START });
export const getCarSuccess = (payload) => ({
  payload,
  type: GET_CAR_SUCCESS,
});
export const getCarFail = () => ({ type: GET_CAR_FAIL });
